import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export function HelpBoxTitle({ children, className }) {
  return <div className={classNames("help-box-title", className)}>{children}</div>;
}

export default function HelpBox({ children, className }) {
  return <div className={classNames("help-box", className)}>{children}</div>;
}

HelpBoxTitle.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};

HelpBox.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
};
